import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { IEpticaExctractEvent } from '@commons/history/history-mail/models/eptica-extract';

@Directive({
  selector: 'mail-comment',
})
export class UpgradedMailCommentDirective extends UpgradeComponent {
  @Input() epticaEvent: IEpticaExctractEvent;
  @Input() showAttachment: boolean;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('mailComment', elementRef, injector);
  }
}
